import { BigNumber, ethers } from 'ethers'

export const applyContractFunctionOverride = (
    args: any[],
    override: Record<string, any> | null,
    additionalHops = 0
) => {
    if (!override) return args

    if (override.gasLimit) {
        // add an extra 10,000 gas to the limit for each additional hop
        const newLimit = Number(override.gasLimit) + 20000 * additionalHops
        override.gasLimit = newLimit.toString()
    }

    const argsHasOverride = !!args[args.length - 1]?.value
    if (!argsHasOverride) return [...args, override]

    const existingOverride = args[args.length - 1] as Record<string, any>
    const mergedOverride = { ...existingOverride, ...override }
    return [...args.slice(0, -1), mergedOverride]
}

export const toReadableValue = (number: BigNumber, decimals?: number) =>
    ethers.utils.formatUnits(number.toString(), decimals)
